import React from 'react';

/* Cordis tokens - scoped to this tab */
const S = {
  bg:    '#FAFAF8',
  bg2:   '#F3F2EF',
  ink:   '#0A1828',
  ink3:  '#4A6278',
  ink4:  '#7A94A8',
  cu:    '#7A5230',
  rule2: 'rgba(10,24,40,0.18)',
  navy:  '#07192A',
};

const F = {
  serif: '"Cormorant Garamond", Georgia, serif',
  mono:  '"DM Mono", ui-monospace, monospace',
  sans:  '"DM Sans", system-ui, sans-serif',
};

function formatGeneratedAt(ts) {
  if (!ts) return null;
  try {
    const d = new Date(ts);
    if (isNaN(d.getTime())) return null;
    const month = d.toLocaleString('en-US', { month: 'short' });
    return `Generated ${month} ${d.getDate()}, ${d.getFullYear()}`;
  } catch {
    return null;
  }
}

export default function BuyerLensAuditTab({ engagement }) {
  const eng = engagement || {};
  const html = eng.buyer_lens_audit_html;
  const hasAudit = typeof html === 'string' && html.trim().length > 0;

  /* ───────── STATE A: no audit yet ───────── */
  if (!hasAudit) {
    return (
      <div style={{
        background: S.bg,
        minHeight: '100%',
        padding: '80px 48px',
        fontFamily: F.sans,
      }}>
        <div style={{
          maxWidth: 720,
          margin: '0 auto',
          borderTop: `1px solid ${S.rule2}`,
          paddingTop: 56,
        }}>
          <div style={{
            fontFamily: F.mono,
            fontSize: 8,
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            color: S.cu,
            marginBottom: 24,
          }}>
            Buyer Lens Audit
          </div>

          <h1 style={{
            fontFamily: F.serif,
            fontWeight: 300,
            fontSize: 28,
            color: S.ink,
            lineHeight: 1.2,
            margin: '0 0 20px',
            letterSpacing: '-0.005em',
          }}>
            Buyer Lens Audit
          </h1>

          <p style={{
            fontFamily: F.sans,
            fontSize: 13,
            color: S.ink3,
            lineHeight: 1.7,
            margin: '0 0 40px',
            maxWidth: 560,
          }}>
            The Buyer Lens Audit for this engagement has not been generated yet.
          </p>

          <button
            type="button"
            disabled
            title="Coming soon"
            style={{
              fontFamily: F.mono,
              fontSize: 10,
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              background: 'transparent',
              color: S.ink4,
              border: `1px solid ${S.rule2}`,
              borderRadius: 0,
              padding: '14px 26px',
              cursor: 'not-allowed',
              opacity: 0.6,
            }}
          >
            Generate Audit
          </button>
        </div>
      </div>
    );
  }

  /* ───────── STATE B: audit exists ───────── */
  const generatedLabel = formatGeneratedAt(eng.buyer_lens_audit_generated_at);

  const toolbarBtnBase = {
    fontFamily: F.mono,
    fontSize: 9,
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    padding: '8px 16px',
    borderRadius: 0,
    cursor: 'not-allowed',
    opacity: 0.55,
    whiteSpace: 'nowrap',
  };

  return (
    <div style={{
      background: S.bg,
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
    }}>
      {/* Toolbar */}
      <div style={{
        height: 40,
        background: S.navy,
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        flexShrink: 0,
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          minWidth: 0,
        }}>
          <span style={{
            fontFamily: F.mono,
            fontSize: 8,
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            color: S.cu,
            whiteSpace: 'nowrap',
          }}>
            Buyer Lens Audit
          </span>
          {generatedLabel && (
            <span style={{
              fontFamily: F.mono,
              fontSize: 8,
              letterSpacing: '0.14em',
              textTransform: 'uppercase',
              color: 'rgba(255,255,255,0.40)',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}>
              {generatedLabel}
            </span>
          )}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button
            type="button"
            disabled
            title="Coming soon"
            style={{
              ...toolbarBtnBase,
              background: 'transparent',
              color: '#FFFFFF',
              border: `1px solid ${S.cu}`,
            }}
          >
            Send to Founder
          </button>
          <button
            type="button"
            disabled
            title="Coming soon"
            style={{
              ...toolbarBtnBase,
              background: S.navy,
              color: '#FFFFFF',
              border: `1px solid rgba(255,255,255,0.25)`,
            }}
          >
            Regenerate
          </button>
        </div>
      </div>

      {/* Audit iframe */}
      <iframe
        title="Buyer Lens Audit"
        srcDoc={html}
        style={{
          width: '100%',
          height: 'calc(100vh - 120px)',
          border: 'none',
          background: S.bg,
        }}
      />
    </div>
  );
}
